import { render, staticRenderFns } from "./DiaryRecord.vue?vue&type=template&id=36d76d6b&scoped=true&"
import script from "./DiaryRecord.vue?vue&type=script&setup=true&lang=js&"
export * from "./DiaryRecord.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d76d6b",
  null
  
)

export default component.exports